import { render } from "./GalleryCollectionDisplay.vue?vue&type=template&id=7e71020c&scoped=true"
import script from "./GalleryCollectionDisplay.vue?vue&type=script&lang=js"
export * from "./GalleryCollectionDisplay.vue?vue&type=script&lang=js"

import "./GalleryCollectionDisplay.vue?vue&type=style&index=0&id=7e71020c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e71020c"]])

export default __exports__